import { useLanguage } from "@/i18n/LanguageContext";

const ITEMS = [
  "Microsoft 365", "Google Workspace", "WhatsApp", "HubSpot", "Salesforce",
  "Odoo", "SAP", "Slack", "Microsoft Teams", "Gmail", "Outlook", "Shopify", "Zoho",
];

const Marquee = () => {
  const { t } = useLanguage();
  return (
  <section className="py-16 border-y border-white/10 overflow-hidden" data-testid="integrations-strip">
    <h2 className="text-center text-xs font-bold tracking-[0.3em] uppercase text-white/40 mb-8 px-6">
      {t.marquee.label}
    </h2>
    <div className="relative">
      <div className="flex w-max marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
            {ITEMS.map((item) => (
              <span key={`${dup}-${item}`} className="flex items-center">
                <span className="marquee-item font-display text-4xl sm:text-6xl font-black uppercase text-outline px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-neon-cyan text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-void to-transparent" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-void to-transparent" />
    </div>
  </section>
  );
};

export default Marquee;
